module.exports = __webpack_public_path__ + "talk.png?00c5e55cca12eb06581b390038764333";


//////////////////
// WEBPACK FOOTER
// ./src/assets/talk.png
// module id = 752
// module chunks = 0